export function unknownValue(text?: string) {
  return typeof text === "string" ? text : "N/A";
}
